import { EHosts } from "libraries/enums/EHosts";
import { FareMethodType } from "libraries/component/booking-information/components/booking-fare-optimisation-card/fare-method-type";

export enum FareOptimisation {
    Accept = 'accept',
    Reject = 'reject',
    fareopt = 'fareopt'
}

export interface IRejectFareOptimisationRequestParams extends IRejectFareOptimisationDataModal{
    rejectionReasonCode: string;
    rejectionType: string;
    otherReason: string;
    fixedDate: string;
    nbDays: number;
    countingFrom: string;
    dummy: boolean;
}

export interface IRejectFareOptimisationDataModal {
    syscode: string;
    host: EHosts;
    priceQuotationTypeReference: string;
    priceStoredFareTypeReference: string;
}

export interface IAcceptFareOptimisationRequestParams {
    syscode: string;
    host: EHosts;
    priceQuotationTypeReference: string;
    priceStoredFareTypeReference: string;
    dummy: boolean;
    method: FareMethodType;
}
